import AssetLoadServiceEvent from "../assetloading/AssetLoadServiceEvent";
import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class LoadStartupAssetsTask extends Task {

    constructor(dispatcher, assetLoadService, startupAssetGroups) {
        super();

        this._dispatcher = dispatcher;
        this._assetLoadService = assetLoadService;
        this._startupAssetGroups = startupAssetGroups;
    }

    execute(callback, progressCallback) {
        const handleProgress = e => {            
            progressCallback(this, e.params.progress);
        }
        const handleComplete = e => {
            this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_PROGRESS, handleProgress);
            this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, handleComplete);
            //Task complete
            callback(this);
        }
        this._dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_PROGRESS, handleProgress);
        this._dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, handleComplete);
        this._assetLoadService.loadGroups.apply(this._assetLoadService, this._startupAssetGroups);
    }
}